// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Privacy Policy Glass Styles
   ========================================== */

.privacy-page, .privacy-policy {
  min-height: 100vh;
  padding: 7.25rem 1.5rem 4rem 1.5rem;
}

.privacy-header {
  text-align: center;
  margin-bottom: 3rem;
  padding: 3rem 2rem;
  background: var(--grad-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-glass);
}

.privacy-header h1 {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.header-subtitle {
  font-size: 1.1rem;
  color: var(--text-muted);
}

.privacy-card {
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-glass);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  max-width: 900px;
  margin: 0 auto;
}

.policy-section {
  padding: 2.5rem;
  border-bottom: 1px solid var(--border-glass);
  display: flex;
  gap: 1.5rem;
}

.section-number {
  width: 42px;
  height: 42px;
  background: var(--grad-primary);
  color: #ffffff !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.section-content h2 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.75rem;
}

.section-content p {
  color: var(--text-muted);
  line-height: 1.7;
}

.info-category h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #a5b4fc;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.privacy-policy a {
  color: #818cf8;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/Components/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":["/* ==========================================\n   Kubersetu Privacy Policy Glass Styles\n   ========================================== */\n\n.privacy-page, .privacy-policy {\n  min-height: 100vh;\n  padding: 7.25rem 1.5rem 4rem 1.5rem;\n}\n\n.privacy-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding: 3rem 2rem;\n  background: var(--grad-surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-glass);\n}\n\n.privacy-header h1 {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.header-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n}\n\n.privacy-card {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-glass);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.policy-section {\n  padding: 2.5rem;\n  border-bottom: 1px solid var(--border-glass);\n  display: flex;\n  gap: 1.5rem;\n}\n\n.section-number {\n  width: 42px;\n  height: 42px;\n  background: var(--grad-primary);\n  color: #ffffff !important;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n.section-content h2 {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.75rem;\n}\n\n.section-content p {\n  color: var(--text-muted);\n  line-height: 1.7;\n}\n\n.info-category h3 {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #a5b4fc;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.privacy-policy a {\n  color: #818cf8;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
